import React from 'react';
import { motion } from 'framer-motion';
export function Slide1Executive() {
  const metrics = [{
    label: 'Page Views',
    value: '73'
  }, {
    label: 'Snak™ Engagers',
    value: '41'
  }, {
    label: 'Engagement Rate',
    value: '57%'
  }, {
    label: 'Qualified Leads',
    value: '12'
  }, {
    label: 'Click-to-Capture',
    value: '28%'
  }];
  return <div className="flex flex-col h-full justify-center max-w-[1400px] mx-auto w-full" data-id="element-548">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2
    }} className="mb-12" data-id="element-549">
        <h1 className="text-5xl md:text-6xl font-display font-bold text-slate-900 mb-8 leading-tight" data-id="element-550">
          A <span className="text-minerva-blue" data-id="element-551">QR-led activation</span> that
          earned real engagement at SNMMI
        </h1>
        <p className="text-xl text-slate-500 max-w-3xl leading-relaxed" data-id="element-552">
          The Snak™ was designed as an aisle breaker. In practice, the booth
          layer was barely used and engagement came almost entirely through the
          QR route — which still converted scan-based curiosity into meaningful
          engagement, qualified leads, and market intelligence on the
          radiopharma challenges that matter most.
        </p>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mt-8" data-id="element-553">
        {metrics.map((metric, i) => <motion.div key={i} initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4 + i * 0.1
      }} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 flex flex-col items-center justify-center text-center hover:shadow-md transition-shadow" data-id="element-554">
            <div className="text-4xl font-bold text-minerva-blue mb-2" data-id="element-555">
              {metric.value}
            </div>
            <div className="text-sm font-medium text-slate-500 uppercase tracking-wider" data-id="element-556">
              {metric.label}
            </div>
          </motion.div>)}
      </div>
    </div>;
}